/**
 * What a visitor to /share/:token should see BEFORE any API call.
 *
 * The ordering matters and is the whole fix for the store-less login loop: the
 * accept request is what returns 401 (requireSession needs session.shop), and
 * the Cognitive Flows axios interceptor turns any 401 into a redirect to
 * /login — so a signed-in user with no store bounced forever. Deciding from
 * cookies first means we simply never make that call.
 */
export function shareVisitorState({ userEmail, shop, stores } = {}) {
    if (!userEmail) return 'anonymous';
    const hasStore = Boolean(shop) || (stores && Object.keys(stores).length > 0);
    return hasStore ? 'ready' : 'store_less';
}
